import React from "react";
import { FaFacebook, FaInstagram, FaTiktok, FaLinkedin } from "react-icons/fa";
import Logo from "../../utils/images/Logo-centrum-for-alla-white-text.webp";
import "./Footer.css";
const logo = Logo;
const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="logo">
            <img src={logo} alt="Logotyp" />
          </div>
          <div className="subscribe">
            <h3>Prenumerera Nu</h3>
            <form>
              <input type="email" placeholder="Ange din e-postadress" />
              <button type="submit">Prenumerera</button>
            </form>
          </div>
        </div>
        <hr />
        <div className="footer-middle">
          <div className="footer-section-about-us">
            <h4>Om Oss</h4>
            <p className="footer-text">
              Centrum för alla är din one-stop shop för alla dina digitala
              behov. Vi erbjuder expertis inom webbdesign, SEO, digital
              marknadsföring, innehållsskapande, PPC-annonsering, e-handel och
              UX-design. Vårt mål är att hjälpa ditt företag att nå sina
              digitala mål och växa online.
            </p>
            <br />
            <div className="social-icons">
              <a
                href="https://www.facebook.com/profile.php?id=61570865498385"
                title="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/centrum_foralla/"
                title="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.tiktok.com/@centrum_for_alla?lang=sv-SE"
                title="Twitter"
              >
                <FaTiktok />
              </a>
              <a
                href="https://linkedin.com/company/centrum-foralla"
                title="LinkedIn"
              >
                <FaLinkedin />
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Användbara Länkar</h4>
            <ul>
              <li>
                <a href="/om-oss">Om Oss</a>
              </li>
              <li>
                <a href="/tjanster">Tjänster</a>
              </li>
              <li>
                <a href="/kundcase">Kundcase</a>
              </li>
              <li>
                <a href="/kontakt">Kontakt</a>
              </li>
              <li>
                <a href="/privacy">Integritetspolicy</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Tjänster</h4>
            <ul>
              <li>
                <a href="/webbdesign">Webbdesign</a>
              </li>
              <li>
                <a href="/seo">SEO-tjänster</a>
              </li>
              <li>
                <a href="/digitalmarknadsforing">Digital Marknadsföring</a>
              </li>
              <li>
                <a href="/innehallsskapande">Innehållsskapande</a>
              </li>
              <li>
                <a href="/ppc-annonsering">PPC-annonsering</a>
              </li>
              <li>
                <a href="/ehandel">E-handel</a>
              </li>
              <li>
                <a href="/uxdesign">UX-design</a>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Senaste Inlägg</h4>
            <ul>
              <li>
                <a href="/marknadsforingskampanj-blog">
                  Digital marknadsföringskampanj
                </a>
              </li>
              <li>
                <a href="/digitala-strategier-blog">Digitala strategier</a>
              </li>
              <li>
                <a href="/seo-grunder-blog">SEO Grunder</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Centrum för alla. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
